const PREVIEW_SESSION_KEY = "tooraflex-admin-storefront-preview";

export const isAdminStorefrontPreview = () => {
  const requestedByUrl =
    new URLSearchParams(window.location.search).get("adminPreview") === "1";

  try {
    if (requestedByUrl) {
      window.sessionStorage.setItem(PREVIEW_SESSION_KEY, "1");
      return true;
    }
    return window.sessionStorage.getItem(PREVIEW_SESSION_KEY) === "1";
  } catch (error) {
    return requestedByUrl;
  }
};
